export default "__VITE_ASSET__CpqhIZKS__"